import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useDataView } from "../../contexts/data.view.context";
import { useConfirmedAddSubmit } from "../shared/useConfirmedAddSubmit";
import ConfirmAddDialog from "../util/confirmAddDialog";
import AddFormLayout from "../shared/AddFormLayout";
import SectionGrid from "../shared/SectionGrid";
import { useSectionedForm } from "../shared/useSectionedForm";

const FORM_SECTIONS = [
  {
    id: "details",
    label: "Schedule details",
    fields: [
      "schedule_id",
      "schedule_cron",
      "schedule_state",
      "schedule_type",
      "schedule_cmd",
      "schedule_group",
    ],
  },
];

const TaskScheduleForm = () => {
  const validationSchema = Yup.object().shape({
    schedule_id: Yup.string().required("Schedule ID is required"),
    //schedule_interval: Yup.string().required("Interval is required"),
    //schedule_count: Yup.string().required("Count is required"),
    schedule_cron: Yup.string().required("Cron is required"),
    schedule_state: Yup.string().required("State is required"),
    schedule_type: Yup.string().required("Type is required"),
    schedule_cmd: Yup.string().required("Command is required"),
    schedule_group: Yup.string().required("Group is required"),
    //parallel_execute: Yup.string().nullable().notRequired().default(""),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { sections, activeId, setActiveId } = useSectionedForm(
    FORM_SECTIONS,
    errors
  );

  const navigate = useNavigate();
  const { fetchTaskSchedulesFromAllEnv } = useDataView();
  const stateItems = ["Active", "Disable"];
  const itemsType = ["crontab", "synapse"];

  const { onSubmit, confirmDialogProps } = useConfirmedAddSubmit({
    resourcePath: "integrations/cfg/schedules",
    notificationTitle: "Query Schedule",
    fetchFn: fetchTaskSchedulesFromAllEnv,
    navigate,
    navigateTo: "/TaskSchedules",
  });

  return (
    <>
      <AddFormLayout
        title="Add query schedule"
        sections={sections}
        activeSectionId={activeId}
        onSectionChange={setActiveId}
        onBack={() => navigate(-1)}
        primaryLabel="Add"
        onPrimaryClick={handleSubmit(onSubmit)}
      >
        <SectionGrid>
          <TextField
            required
            label="ID"
            size="small"
            fullWidth
            {...register("schedule_id")}
            error={!!errors.schedule_id}
            variant="outlined"
          />
          <TextField
            required
            label="Cron"
            size="small"
            fullWidth
            {...register("schedule_cron")}
            error={!!errors.schedule_cron}
            variant="outlined"
          />
          <TextField
            select
            label="State"
            size="small"
            fullWidth
            {...register("schedule_state")}
            error={!!errors.schedule_state}
            variant="outlined"
          >
            {stateItems.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Type"
            size="small"
            fullWidth
            {...register("schedule_type")}
            error={!!errors.schedule_type}
            variant="outlined"
          >
            {itemsType.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            required
            label="Command"
            size="small"
            fullWidth
            {...register("schedule_cmd")}
            error={!!errors.schedule_cmd}
            variant="outlined"
          />
          <TextField
            required
            label="Group"
            size="small"
            fullWidth
            {...register("schedule_group")}
            error={!!errors.schedule_group}
            variant="outlined"
          />
        </SectionGrid>
      </AddFormLayout>

      <ConfirmAddDialog {...confirmDialogProps} itemLabel="query schedule" />
    </>
  );
};

export default TaskScheduleForm;
